import { observer } from 'mobx-react-lite'
import { SectionCollapse } from 'shared/ui'
import { useChatbotContext } from 'pages/chatbot/context'
import { StepHandoffContent } from 'pages/chatbot/ui/ChatbotEdit/StepHandoff/ui/StepHandoffContent/StepHandoffContent.tsx'

export const StepHandoff = observer(() => {
  const { errorHandoff } = useChatbotContext()

  return (
    <SectionCollapse
      icon='userRight'
      title='Handoff to human'
      tooltipProps={{
        label: 'Hand off the conversation if the AI Agent can’t help',
        placement: 'top',
        sx: { whiteSpace: 'nowrap' },
        maxWidth: 'none',
      }}
      error={errorHandoff}
      dataError={!!errorHandoff}
    >
      <StepHandoffContent type={'default'} />
    </SectionCollapse>
  )
})
